/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQueryRecordState extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQueryRecordState");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQueryRecordState.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQueryRecordState>): AwsSecurityHubFindingQueryRecordState {
        let obj = Object.assign(new AwsSecurityHubFindingQueryRecordState(), model);
        AwsSecurityHubFindingQueryRecordState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQueryRecordState>): AwsSecurityHubFindingQueryRecordState {
        if (!model) return null;
        return AwsSecurityHubFindingQueryRecordState.newInstance(<AwsSecurityHubFindingQueryRecordState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQueryRecordState) {
        if (!obj) return;

        models.AwsSecurityHubFindingQueryRecordState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQueryRecordState): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQueryRecordState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Record States for the resources
     */
    record_states: Array<string>;

}
